import HSATransactionInformationModal from './HSATransactionInformationModal';
import Button from '../../../components/Button';
import { Container } from 'react-bootstrap';
import useModal from '../../../hooks/useModal';
import { DateFormats, formatDate, formatPrice } from '../../../utils/utils';

const HSATransactionData = [
  {
    date: formatDate(new Date(2020, 2, 7), DateFormats.US),
    transaction: 'HSA One-Time Contribution',
    amount: formatPrice(1200.0),
    status: 'Pending',
  },
  {
    date: formatDate(new Date(2020, 2, 7), DateFormats.US),
    transaction: 'HSA Two-Time Contribution',
    amount: formatPrice(1200.0),
    status: 'Complete',
  },
];

const HSATransactionInformationModalDemo = () => {
  const [show, handleShow, handleClose] = useModal();

  return (
    <Container>
      <h4>Transaction Information Modal</h4>
      <Button onClick={handleShow}>HSA Transaction Information</Button>
      <HSATransactionInformationModal
        showModal={show}
        handleCloseModal={handleClose}
        data={HSATransactionData}
      />
    </Container>
  );
};

export default HSATransactionInformationModalDemo;
